import { createFileRoute, redirect } from '@tanstack/react-router'
import { APP_ROUTES } from '@shared/app-routes'

export const Route = createFileRoute('/settings')({
  beforeLoad: () => {
    throw redirect({ to: APP_ROUTES.dashboard.settings })
  },
  component: SettingsRedirect,
})

function SettingsRedirect() {
  return null
}
